import { useState, useEffect } from 'react'

interface HumanCommentCardProps {
  replies: string[]
  isOpen: boolean
  onSubmit: (text: string) => void
  onCancel: () => void
}

export function HumanCommentCard({ replies, isOpen, onSubmit, onCancel }: HumanCommentCardProps) {
  const [replyOpen, setReplyOpen] = useState(isOpen)
  const [text, setText] = useState('')

  useEffect(() => {
    if (isOpen) setReplyOpen(true)
  }, [isOpen])

  function handleSubmit() {
    if (!text.trim()) return
    onSubmit(text.trim())
    setText('')
    setReplyOpen(false)
  }

  function handleCancel() {
    setText('')
    setReplyOpen(false)
    onCancel()
  }

  return (
    <div className="flex border border-border-default rounded-md overflow-hidden">
      <div className="flex-1 px-3 py-[7px] flex flex-col gap-[5px] min-w-0">
        {replies.map((r, i) => (
          <div
            key={i}
            className="text-[11px] text-fg-muted bg-canvas border border-border-subtle rounded-[3px] px-2 py-1.5"
          >
            <span className="text-fg-dim text-[10px] block mb-0.5">you · just now</span>
            {r}
          </div>
        ))}

        <div className="flex gap-1.5 mt-1">
          <button className="btn btn-default" onClick={() => setReplyOpen((o) => !o)}>
            ↩ Reply
          </button>
        </div>

        {replyOpen && (
          <div className="mt-2 flex flex-col gap-1.5">
            <textarea
              className="textarea text-[12px]"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder={replies.length > 0 ? 'Reply…' : 'Leave a comment…'}
              rows={2}
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault()
                  handleSubmit()
                }
                if (e.key === 'Escape') handleCancel()
              }}
            />
            <div className="flex gap-1.5 justify-end">
              <button className="btn btn-default" onClick={handleCancel}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={!text.trim()}
              >
                Submit
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
